import React, { createContext, useContext } from 'react';
import { Building2, ChevronDown } from 'lucide-react';
import './client-match.css';

export const ProjectClientContext = createContext<{
    name: string;
    linked: boolean;
    busy: boolean;
    busyReason?: string | null;
    /** The requester email the server linked this job from on this open (SPEC 2026-10-08 D2). */
    matchedFrom?: string | null;
    open: () => void;
} | null>(null);
export const useProjectClientControl = () => useContext(ProjectClientContext);

/** Compact action for the existing project header, with a full accessible name. */
export function ProjectClientControl({ fallback = null, tone = 'dark' }: { fallback?: React.ReactNode; tone?: 'dark' | 'light' }) {
    const client = useProjectClientControl();
    if (!client) return <>{fallback}</>;
    const action = client.linked ? 'Change client' : 'Match client';
    const matchedFrom = client.linked && client.matchedFrom ? `Matched from ${client.matchedFrom}` : '';
    const label = client.linked ? `${action}: ${client.name}${matchedFrom ? `. ${matchedFrom}` : ''}` : action;
    return <button type="button" className={`crm-project-client-control crm-project-client-control--${tone}`} data-linked={client.linked}
        data-matched={matchedFrom ? 'true' : undefined}
        disabled={client.busy} onClick={client.open} aria-label={label}
        title={client.busy && client.busyReason ? client.busyReason : client.linked ? `${client.name}${matchedFrom ? ` · ${matchedFrom}` : ''} · Change the client record` : 'Choose an existing client or confirm a new record'} aria-haspopup="dialog">
        <Building2 size={16} aria-hidden="true" />
        <span className="crm-project-client-control-name">{client.linked ? client.name : action}</span>
        {matchedFrom && <span className="crm-project-client-control-note" aria-hidden="true">{matchedFrom}</span>}
        {!client.linked && <span className="crm-project-client-control-short" aria-hidden="true">Match</span>}
        {client.linked && <span className="crm-project-client-control-action">Change</span>}
        <ChevronDown size={13} aria-hidden="true" />
    </button>;
}
